"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var system_1 = require("@mui/system");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var OptionChip = (0, system_1.styled)(Chip_1.default)(function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme;
    return ({
        backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.light,
        borderColor: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.light,
        color: (_d = theme.palette.neutral) === null || _d === void 0 ? void 0 : _d.dark,
        fontWeight: 500,
        borderRadius: 5,
        marginRight: theme.spacing(1),
        '.MuiChip-deletable': {
            color: (_e = theme.palette.neutral) === null || _e === void 0 ? void 0 : _e.dark,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(OptionChip, {
    variant: 'filled',
    size: 'small',
});
